import { render, staticRenderFns } from "./impr.vue?vue&type=template&id=0d418100"
import script from "./impr.vue?vue&type=script&lang=js"
export * from "./impr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d418100')) {
      api.createRecord('0d418100', component.options)
    } else {
      api.reload('0d418100', component.options)
    }
    module.hot.accept("./impr.vue?vue&type=template&id=0d418100", function () {
      api.rerender('0d418100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/impr.vue"
export default component.exports